import * as actionTypes from "../actions/actionTypes";
import _ from "lodash";

const INITIAL_STATE = {
  menuList: [],
  menuList_two: [],
  menuDetail: {},
  isLoading: false,
  isLoadingCategory: false,
  isLoadingCategoryMenu: false,
  categoryLoadSuccess: false,
};

export default function menuReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.LOAD_RESTAURANT_MENU_LIST:
      return {
        ...state,
        menuList: [],
        isLoading: true,
      };
    case actionTypes.LOAD_RESTAURANT_MENU_LIST_FAIL: {
      return {
        ...state,
        menuList: INITIAL_STATE.menuList,
        isLoading: false,
      };
    }
    case actionTypes.LOAD_RESTAURANT_MENU_LIST_SUCCESS: {
      let menuList = [];

      if (action.data.length !== 0) {
        if (action.data[0].category) {
          // basic set method
          // action.data.forEach(data => {
          //   menuList.push({
          //     category: data.category,
          //     item: [...data.item, ...data.item2]
          //   });
          // });

          // set method that assign out of stock last
          action.data.forEach((data) => {
            let newMenu = JSON.parse(JSON.stringify(data));
            newMenu.item = newMenu.item.concat(newMenu.item2); // merge items
            newMenu.item2 = []; // clear item
            newMenu.item = _.sortBy(
              newMenu.item,
              (eachItem) => eachItem.outOfStock
            );
            menuList.push({
              category: newMenu.category,
              item: [...newMenu.item, ...newMenu.item2],
            });
          });
        } else {
          // If load top sales only
          menuList.push({
            category: "top sales",
            item: [...action.data],
          });
        }
      }

      return {
        ...state,
        menuList,
        isLoading: false,
      };
    }

    /////////* New Menu Loading Method START *//////////
    case actionTypes.LOAD_RESTAURANT_MENU_CATEGORY: {
      return {
        ...state,
        menuList_two: [],
        isLoadingCategory: true,
        categoryLoadSuccess: false,
      };
    }
    case actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_FAIL: {
      return {
        ...state,
        menuList_two: INITIAL_STATE.menuList_two,
        isLoadingCategory: false,
        categoryLoadSuccess: false,
      };
    }
    case actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_SUCCESS: {
      let menuList_two = [];
      if (action.data.length > 0) {
        action.data.forEach((category_name, index) => {
          if (
            category_name.publish &&
            category_name.publish === 1 &&
            category_name.has_items &&
            category_name.has_items === true
          ) {
            menuList_two.push({
              category: category_name.name,
              item: [],
              isLoaded: false,
            });
          }
        });
      }
      return {
        ...state,
        menuList_two,
        isLoadingCategory: false,
        categoryLoadSuccess: true,
      };
    }
    case actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_ITEMS: {
      return {
        ...state,
        isLoadingCategoryMenu: true,
      };
    }
    case actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_ITEMS_FAIL: {
      return {
        ...state,
        isLoadingCategoryMenu: false,
      };
    }
    case actionTypes.LOAD_RESTAURANT_MENU_CATEGORY_ITEMS_SUCCESS: {
      let menuList_two = state.menuList_two;
      // pass index into action.data.index and data inside action.data.data
      let index = action.data.index;
      let data = action.data.data;
      menuList_two[index].isLoaded = true;
      if (action.data.data && action.data.data.length > 0) {
        let catMenu = [];
        if (
          data.length > index &&
          data[index] &&
          data[index].category === menuList_two[index].category
        ) {
          catMenu = JSON.parse(JSON.stringify(data[index]));
        } else {
          catMenu = JSON.parse(JSON.stringify(data[0]));
        }
        catMenu.item = catMenu.item.concat(catMenu.item2); // merge items
        catMenu.item2 = []; // clear item
        catMenu.item = _.sortBy(
          catMenu.item,
          (eachItem) => eachItem.outOfStock
        );
        menuList_two[index].item = catMenu.item;
      }
      return {
        ...state,
        menuList_two: menuList_two,
        isLoadingCategoryMenu: false,
      };
    }
    /////////*  New Menu Loading Method END  *//////////

    case actionTypes.LOAD_RESTAURANT_MENU_DETAIL:
    case actionTypes.LOAD_RESTAURANT_MENU_DETAIL_FAIL: {
      return {
        ...state,
        menuDetail: {},
      };
    }

    case actionTypes.LOAD_RESTAURANT_MENU_DETAIL_SUCCESS: {
      return {
        ...state,
        menuDetail: action.data,
      };
    }
    default:
      return state;
  }
}
